import { useEffect, useRef, useState } from 'react';
import './Billetterie.css';

const VIEWS = ['billetterie', 'salon', 'admin', 'scan', 'cashless', 'sponsors'];

const VIEW_LABELS = {
  billetterie: '🎵 Billetterie Concert',
  salon: '🏢 Salon Professionnel',
  admin: '⚙️ Back-office',
  scan: '📱 Scan QR Entrée',
  cashless: '💳 Cashless',
  sponsors: '📣 Sponsors & Pub',
};

// ── DATA : sièges (structure stable; vendus = set initial) ──
const VIP_ROWS = [
  { row: 'A', seats: [1, 2, 3, 4, '|', 5, 6, 7, 8] },
  { row: 'B', seats: [1, 2, 3, 4, '|', 5, 6, 7, 8] },
];
const PARTNER_ROWS = [
  { row: 'C', seats: [1, 2, 3, 4, '|', 5, 6, 7, 8, 9, 10] },
  { row: 'D', seats: [1, 2, 3, 4, '|', 5, 6, 7, 8, 9, 10] },
];
const STD_ROWS = [
  { row: 'E', seats: [1, 2, 3, 4, 5, '|', 6, 7, 8, 9, 10, 11] },
  { row: 'F', seats: [1, 2, 3, 4, 5, '|', 6, 7, 8, 9, 10, 11] },
];
const INITIAL_SOLD = new Set([
  'A-3', 'A-4', 'A-5', 'B-1', 'B-4', 'B-7',
  'C-3', 'C-5', 'C-8', 'D-1', 'D-6', 'D-8',
  'E-2', 'E-4', 'E-5', 'E-8', 'E-12', 'F-1', 'F-4', 'F-6', 'F-8', 'F-10',
]);

const ZONE_CONFIG = {
  VIP: { prixPublic: 45, prixMembre: 32, color: 'var(--gold)', chipClass: 'chip-gold' },
  Partenaire: { prixPublic: 35, prixMembre: 25, color: 'var(--purple)', chipClass: 'chip-purple' },
  Standard: { prixPublic: 25, prixMembre: 18, color: 'var(--blue)', chipClass: 'chip-blue' },
  Debout: { prixPublic: 15, prixMembre: 10, color: 'var(--green)', chipClass: 'chip-ok' },
};

const SCAN_PERSONS = [
  { name: 'Alice Leroy', seat: 'C-6', zone: 'Partenaire', ok: true },
  { name: 'Marc Girard', seat: 'E-9', zone: 'Standard', ok: true },
  { name: 'Laura Blanc', seat: 'Fosse', zone: 'Debout', ok: true },
  { name: 'Billet invalide', seat: '—', zone: '—', ok: false },
];

const SALON_EMPLACEMENTS = [
  // row 1
  { id: 'S-01', type: 'Standard', cls: 'standard-emp', surface: '6m²', prix: 350, label: 'S-01', color: 'var(--green)' },
  { id: 'S-02', type: 'Standard', cls: 'standard-emp', surface: '6m²', prix: 350, label: 'S-02', sold: true, company: 'BTP Quercy', color: 'var(--green)' },
  { id: 'P-01', type: 'Premium', cls: 'premium', surface: '9m²', prix: 550, label: 'P-01 ⭐', color: 'var(--blue)' },
  { id: 'P-02', type: 'Premium', cls: 'premium', surface: '9m²', prix: 550, label: 'P-02', sold: true, company: 'Crédit Agricole', color: 'var(--blue)' },
  { id: 'S-03', type: 'Standard', cls: 'standard-emp', surface: '6m²', prix: 350, label: 'S-03', color: 'var(--green)' },
  { id: 'S-04', type: 'Standard', cls: 'standard-emp', surface: '6m²', prix: 350, label: 'S-04', color: 'var(--green)' },
  // row 2 (Corner + Island span 2)
  { id: 'C-01', type: 'Corner', cls: 'corner', surface: '12m²', prix: 800, label: 'C-01 🔝', color: 'var(--purple)' },
  { id: 'I-01', type: 'Island — Îlot Central', cls: 'island', surface: '16m² · Central', prix: 1200, label: 'ISLAND I-01 🏆', sold: true, span: 2, company: 'Mairie de Lyon', color: 'var(--gold)' },
  { id: 'I-02', type: 'Island — Îlot Central', cls: 'island', surface: '16m² · Toutes faces', prix: 1200, label: 'ISLAND I-02 🏆', span: 2, color: 'var(--gold)' },
  { id: 'C-02', type: 'Corner', cls: 'corner', surface: '12m²', prix: 800, label: 'C-02 🔝', color: 'var(--purple)' },
  // row 3
  { id: 'P-03', type: 'Premium', cls: 'premium', surface: '9m²', prix: 550, label: 'P-03', sold: true, company: 'REF Fugakwa', color: 'var(--blue)' },
  { id: 'P-04', type: 'Premium', cls: 'premium', surface: '9m²', prix: 550, label: 'P-04 ⭐', color: 'var(--blue)' },
  { id: 'S-05', type: 'Standard', cls: 'standard-emp', surface: '6m²', prix: 350, label: 'S-05', color: 'var(--green)' },
  { id: 'S-06', type: 'Standard', cls: 'standard-emp', surface: '6m²', prix: 350, label: 'S-06', color: 'var(--green)' },
  { id: 'P-05', type: 'Premium', cls: 'premium', surface: '9m²', prix: 550, label: 'P-05', sold: true, company: 'Chambre Commerce', color: 'var(--blue)' },
  { id: 'C-03', type: 'Corner', cls: 'corner', surface: '12m²', prix: 800, label: 'C-03', sold: true, company: 'BNP Paribas', color: 'var(--purple)' },
];

export default function BilletterieDemo() {
  const [view, setView] = useState('billetterie');
  const [soldSeats, setSoldSeats] = useState(INITIAL_SOLD);
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [tarifType, setTarifType] = useState('public');
  const [standingActive, setStandingActive] = useState(false);

  // Modals
  const [modalBillet, setModalBillet] = useState(false);
  const [modalEmplacement, setModalEmplacement] = useState(null); // emplacement obj
  const [modalSuccess, setModalSuccess] = useState(null); // {icon, title, msg}

  // Forms
  const [billetName, setBilletName] = useState('');
  const [billetEmail, setBilletEmail] = useState('');
  const [empCompany, setEmpCompany] = useState('');
  const [empEmail, setEmpEmail] = useState('');
  const [empContact, setEmpContact] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Counters
  const [placesRestantes, setPlacesRestantes] = useState(47);
  const [kpiBillets, setKpiBillets] = useState(153);
  const [scanTotal, setScanTotal] = useState(153);

  // Cashless
  const [cashBalance, setCashBalance] = useState(24.50);
  const [cashRecharge, setCashRecharge] = useState(1240);

  // Scan
  const [scanIdx, setScanIdx] = useState(0);
  const [scanResult, setScanResult] = useState(null);
  const [scanOkCount, setScanOkCount] = useState(89);
  const [scanHistory, setScanHistory] = useState([
    { icon: '✅', name: 'Marie Dupont', meta: 'Siège A-2 · VIP · 21h04', ok: true },
    { icon: '✅', name: 'Jean Martin', meta: 'Siège A-1 · VIP · 20h58', ok: true },
    { icon: '❌', name: 'Billet inconnu', meta: 'QR invalide · 20h45', ok: false },
  ]);

  // Toasts
  const [toasts, setToasts] = useState([]);
  const toastIdRef = useRef(0);

  // Load fonts
  useEffect(() => {
    const id = 'billetterie-fonts';
    if (!document.getElementById(id)) {
      const link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,700;0,900;1,900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const toast = (msg) => {
    const id = ++toastIdRef.current;
    setToasts((t) => [...t, { id, msg, show: false }]);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => setToasts((t) => t.map((x) => x.id === id ? { ...x, show: true } : x)));
    });
    setTimeout(() => {
      setToasts((t) => t.map((x) => x.id === id ? { ...x, show: false } : x));
      setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 400);
    }, 3200);
  };

  const switchView = (v) => { setView(v); window.scrollTo(0, 0); };

  const selectSeat = (id, zone) => {
    if (soldSeats.has(id)) return;
    const cfg = getZoneConfig(zone);
    setSelectedSeat({ id, zone, prixPublic: cfg.prixPublic, prixMembre: cfg.prixMembre });
    setTarifType('public');
    setStandingActive(false);
  };

  const selectStanding = () => {
    setStandingActive(true);
    const cfg = getZoneConfig('Debout');
    setSelectedSeat({ id: 'Fosse', zone: 'Debout', prixPublic: cfg.prixPublic, prixMembre: cfg.prixMembre });
    setTarifType('public');
  };

  const currentPrice = selectedSeat ? (tarifType === 'public' ? selectedSeat.prixPublic : selectedSeat.prixMembre) : 0;

  const getZoneConfig = (zoneId) => ZONE_CONFIG[zoneId] || ZONE_CONFIG.VIP;

  const ouvrirAchat = () => {
    if (!selectedSeat) { toast('⚠️ Sélectionnez d\'abord une place'); return; }
    setBilletName(''); setBilletEmail('');
    setModalBillet(true);
  };

  const acheterBillet = async () => {
    if (!billetName || !billetEmail) { toast('⚠️ Merci de remplir votre nom et email'); return; }
    setSubmitting(true);

    // ── Mode démo (state local) ──
    setTimeout(() => {
      setSubmitting(false);
      setModalBillet(false);
      if (selectedSeat && selectedSeat.id !== 'Fosse') {
        setSoldSeats((s) => { const next = new Set(s); next.add(selectedSeat.id); return next; });
      }
      setPlacesRestantes((p) => Math.max(0, p - 1));
      setKpiBillets((k) => k + 1);
      setScanTotal((s) => s + 1);
      setModalSuccess({
        icon: '🎫',
        title: 'Billet confirmé !',
        msg: `Votre billet QR code a été envoyé à ${billetEmail}. Présentez-le à l'entrée du Caveau Blues. Bonne soirée !`,
      });
      setSelectedSeat(null);
      setStandingActive(false);
    }, 1500);
  };

  const ouvrirEmplacement = (emp) => {
    if (emp.sold) return;
    setEmpCompany(''); setEmpEmail(''); setEmpContact('');
    setModalEmplacement(emp);
  };

  const reserverEmplacement = () => {
    if (!empCompany || !empEmail) { toast('⚠️ Société et email obligatoires'); return; }
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      const empId = modalEmplacement.id;
      setModalEmplacement(null);
      setModalSuccess({
        icon: '🏢',
        title: 'Emplacement réservé !',
        msg: `Votre emplacement ${empId} au Forum Business Lyon 2024 est confirmé. Plan d'accès et badge exposant envoyés à ${empEmail}.`,
      });
      toast('✅ Emplacement réservé — Facture envoyée par email');
    }, 1400);
  };

  const simulerScan = () => {
    const person = SCAN_PERSONS[scanIdx % SCAN_PERSONS.length];
    setScanIdx((i) => i + 1);
    setScanResult(person);
    if (person.ok) {
      setScanOkCount((c) => c + 1);
      setScanHistory((h) => [
        { icon: '✅', name: person.name, meta: `Siège ${person.seat} · ${person.zone} · Maintenant`, ok: true },
        ...h,
      ]);
    }
    setTimeout(() => setScanResult(null), 4000);
  };

  const addBalance = (amount) => {
    setCashBalance((b) => b + amount);
    setCashRecharge((r) => r + amount);
    toast(`✅ ${amount}€ ajoutés ! Nouveau solde : ${(cashBalance + amount).toFixed(2)}€`);
  };

  const payer = (amount, item) => {
    if (cashBalance < amount) { toast(`❌ Solde insuffisant (${cashBalance.toFixed(2)}€) — Rechargez votre carte`); return; }
    setCashBalance((b) => b - amount);
    toast(`✅ ${item} — ${amount}€ déduits. Solde restant : ${(cashBalance - amount).toFixed(2)}€`);
  };

  // ── RENDERS ──

  const renderSeatRow = (rowObj, zone) => {
    const cfg = getZoneConfig(zone);
    const cls = zone === 'VIP' ? 'vip' : zone === 'Partenaire' ? 'partner' : 'standard';
    return (
      <div className="seat-row" key={`${zone}-${rowObj.row}`}>
        <div className="row-label" style={{ color: cfg.color }}>{rowObj.row}</div>
        {rowObj.seats.map((seat, idx) => {
          if (seat === '|') return <div className="aisle" key={idx}></div>;
          const id = `${rowObj.row}-${seat}`;
          const isSold = soldSeats.has(id);
          const isSelected = selectedSeat && selectedSeat.id === id;
          const letter = zone === 'VIP' ? 'V' : zone === 'Partenaire' ? 'P' : 'S';
          return (
            <div
              key={id}
              className={`seat ${cls}${isSold ? ' sold' : ''}${isSelected ? ' selected-seat' : ''}`}
              onClick={() => selectSeat(id, zone)}
              role="button"
              tabIndex={isSold ? -1 : 0}
              aria-disabled={isSold ? 'true' : 'false'}
              aria-label={isSold ? `Siège ${id} — vendu` : `Siège ${id} — disponible`}
              title={isSold ? `${id} — Vendu` : id}
              data-testid={`seat-${id}`}
              data-sold={isSold ? 'true' : 'false'}
            >{isSold ? '' : letter}</div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="billetterie-root" data-testid="billetterie-root">
      {/* TOASTS */}
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={'toast' + (t.show ? ' show' : '')}>{t.msg}</div>
        ))}
      </div>

      {/* NAV */}
      <div className="main-tabs">
        <div className="tabs-logo">
          🎵 <span>AssoPerf</span> Billetterie & Salons
        </div>
        <div className="tabs-center">
          {VIEWS.map((v) => (
            <button
              key={v}
              className={'tab-btn' + (view === v ? ' active' : '')}
              onClick={() => switchView(v)}
              data-testid={`tab-${v}`}
            >{VIEW_LABELS[v]}</button>
          ))}
        </div>
        <div className="tabs-right">
          <button className="btn btn-ghost btn-sm" onClick={() => toast('Connexion à votre espace AssoPerf')}>← AssoPerf</button>
          <button className="btn btn-gold btn-sm" onClick={() => switchView('admin')}>Tableau de bord</button>
        </div>
      </div>

      {/* ════ VUE 1 : BILLETTERIE CONCERT ════ */}
      <div className={'view' + (view === 'billetterie' ? ' active' : '')} style={{ paddingTop: '62px' }} data-testid="view-billetterie">
        {/* HERO */}
        <div className="billetterie-hero-section" style={{ background: 'linear-gradient(180deg,#0a0f18,#05080a)', padding: '50px 32px 30px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
            <div className="billetterie-hero-row">
              <div className="billetterie-hero-img">🎷</div>
              <div className="billetterie-hero-content">
                <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', flexWrap: 'wrap' }}>
                  <span className="chip chip-ok">🟢 Billetterie ouverte</span>
                  <span className="chip chip-gold">⭐ Soirée phare</span>
                  <span className="chip chip-cyan">📱 QR code + Cashless</span>
                </div>
                <div style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(24px,4vw,48px)', fontWeight: 900, lineHeight: 1.1, marginBottom: '10px' }} data-testid="event-title">
                  Jazz Night<br /><span style={{ color: 'var(--gold)' }}>Vendredi 20 Juin</span>
                </div>
                <div style={{ fontSize: '14px', color: 'var(--muted)', marginBottom: '6px' }} data-testid="event-lieu">
                  📍 Le Caveau Blues · 14 rue Mercière · Lyon 1er
                </div>
                <div style={{ fontSize: '14px', color: 'var(--muted)', marginBottom: '16px' }}>
                  🕗 20h30 → 00h00 · Portes ouvertes à 19h30
                </div>
                <div style={{ fontSize: '14px', color: 'var(--muted)', marginBottom: '16px' }}>🎷 <strong style={{ color: 'var(--text)' }}>Marcus Rivet Quartet</strong> + <strong style={{ color: 'var(--text)' }}>DJ Set Lola K</strong></div>
                <div className="billetterie-stats-row">
                  <div className="billetterie-stat-card">
                    <div style={{ fontSize: '22px', fontWeight: 800, color: 'var(--gold)' }} data-testid="places-restantes">{placesRestantes}</div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)' }}>Places restantes</div>
                  </div>
                  <div className="billetterie-stat-card">
                    <div style={{ fontSize: '22px', fontWeight: 800, color: 'var(--green)' }} data-testid="billets-vendus">{kpiBillets}</div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)' }}>Billets vendus</div>
                  </div>
                  <div className="billetterie-stat-card">
                    <div style={{ fontSize: '22px', fontWeight: 800, color: 'var(--cyan)' }} data-testid="capacite">200</div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)' }}>Capacité totale</div>
                  </div>
                </div>
              </div>
              <div className="billetterie-hero-tarifs" style={{ background: 'var(--surface)', border: '1px solid var(--gold-border)', borderRadius: '16px', padding: '20px' }}>
                <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '14px', color: 'var(--gold)' }}>🎫 Tarifs</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }} data-testid="tarifs-panel">
                  {[
                    { zone: '⭐ VIP', price: '45€', bg: 'var(--gold-soft)', border: 'var(--gold-border)', color: 'var(--gold)' },
                    { zone: '🤝 Partenaire', price: '35€', bg: 'rgba(155,89,182,0.08)', border: 'rgba(155,89,182,0.2)', color: 'var(--purple)' },
                    { zone: '🪑 Standard', price: '25€', bg: 'rgba(79,138,255,0.08)', border: 'rgba(79,138,255,0.2)', color: 'var(--blue)' },
                    { zone: '🕺 Debout', price: '15€', bg: 'rgba(34,211,160,0.06)', border: 'rgba(34,211,160,0.2)', color: 'var(--green)' },
                  ].map((t) => (
                    <div key={t.zone} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: t.bg, border: `1px solid ${t.border}`, borderRadius: '8px' }}>
                      <span style={{ fontWeight: 700 }}>{t.zone}</span><span style={{ fontWeight: 800, color: t.color }}>{t.price}</span>
                    </div>
                  ))}
                  <div style={{ fontSize: '11px', color: 'var(--green)', padding: '4px 0', textAlign: 'center' }}>🎁 Membres REF : -30% sur tous les tarifs</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PLAN DE SALLE + PANIER */}
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '28px 24px' }}>
          <div className="g2" style={{ gap: '24px', alignItems: 'start' }}>
            <div>
              <div style={{ fontSize: '15px', fontWeight: 800, marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                🗺️ Plan de salle interactif
                <span style={{ fontSize: '12px', fontWeight: 400, color: 'var(--muted)' }}>Cliquez sur une place</span>
              </div>
              <div className="salle-container">
                <div className="scene-band">🎵 Scène 🎵</div>

                <div className="zone-header" style={{ color: 'var(--gold)' }}>⭐ Zone VIP — 45€ (membres : 32€)</div>
                <div className="seats-grid">
                  {VIP_ROWS.map((r) => renderSeatRow(r, 'VIP'))}
                </div>

                <div className="zone-header" style={{ color: 'var(--purple)' }}>🤝 Zone Partenaire — 35€ (membres : 25€)</div>
                <div className="seats-grid">
                  {PARTNER_ROWS.map((r) => renderSeatRow(r, 'Partenaire'))}
                </div>

                <div className="zone-header" style={{ color: 'var(--blue)' }}>🪑 Zone Standard — 25€ (membres : 18€)</div>
                <div className="seats-grid">
                  {STD_ROWS.map((r) => renderSeatRow(r, 'Standard'))}
                </div>

                <div className="zone-header" style={{ color: 'var(--green)' }}>🕺 Zone Debout — 15€ (membres : 10€)</div>
                <div className={'standing-area' + (standingActive ? ' active' : '')} onClick={selectStanding} data-testid="standing-area">
                  <div style={{ fontSize: '22px', marginBottom: '6px' }}>🕺💃</div>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--green)' }}>Zone Debout — Fosse</div>
                  <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '4px' }}>38 places disponibles sur 80</div>
                  <div style={{ fontSize: '11px', color: 'var(--green)', marginTop: '6px' }}>Cliquez pour sélectionner</div>
                </div>

                <div className="seat-legend">
                  <div className="leg"><div className="leg-dot" style={{ background: 'var(--gold)', opacity: 0.7 }}></div>VIP (dispo)</div>
                  <div className="leg"><div className="leg-dot" style={{ background: 'var(--purple)', opacity: 0.7 }}></div>Partenaire</div>
                  <div className="leg"><div className="leg-dot" style={{ background: 'var(--blue)', opacity: 0.7 }}></div>Standard</div>
                  <div className="leg"><div className="leg-dot" style={{ background: 'var(--green)', opacity: 0.5 }}></div>Debout</div>
                  <div className="leg"><div className="leg-dot" style={{ background: 'var(--surface2)', border: '1px solid var(--border)' }}></div>Vendu</div>
                </div>
              </div>
            </div>

            {/* PANEL DROIT */}
            <div>
              <div className="card" style={{ marginBottom: '14px', borderColor: 'var(--gold-border)' }}>
                <div className="card-hdr" style={{ borderBottomColor: 'var(--gold-border)' }}>
                  <div className="card-title" style={{ color: 'var(--gold)' }}>🛒 Votre sélection</div>
                </div>
                <div className="card-body">
                  {!selectedSeat ? (
                    <div style={{ textAlign: 'center', padding: '20px', color: 'var(--muted)', fontSize: '13px' }} data-testid="panier-empty">
                      <div style={{ fontSize: '28px', marginBottom: '8px' }}>👆</div>
                      Cliquez sur une place pour la sélectionner
                    </div>
                  ) : (
                    <div data-testid="panier-content">
                      <div style={{ background: 'var(--surface2)', borderRadius: '10px', padding: '12px', marginBottom: '12px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                          <div style={{ fontSize: '13px', fontWeight: 700 }} data-testid="panier-seat">
                            {selectedSeat.id === 'Fosse' ? 'Zone Debout — Fosse' : `Siège ${selectedSeat.id} — Zone ${selectedSeat.zone}`}
                          </div>
                          <span className={'chip ' + getZoneConfig(selectedSeat.zone).chipClass}>{selectedSeat.zone}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                          <div
                            onClick={() => setTarifType('public')}
                            style={{ flex: 1, padding: '8px', borderRadius: '8px', background: tarifType === 'public' ? 'var(--gold-soft)' : 'var(--surface2)', border: tarifType === 'public' ? '2px solid var(--gold)' : '2px solid var(--border)', textAlign: 'center', cursor: 'pointer' }}
                            data-testid="tarif-public"
                          >
                            <div style={{ fontSize: '10px', color: tarifType === 'public' ? 'var(--gold)' : 'var(--muted)' }}>Public</div>
                            <div style={{ fontSize: '16px', fontWeight: 800, color: tarifType === 'public' ? 'var(--gold)' : 'var(--text)' }}>{selectedSeat.prixPublic}€</div>
                          </div>
                          <div
                            onClick={() => setTarifType('membre')}
                            style={{ flex: 1, padding: '8px', borderRadius: '8px', background: tarifType === 'membre' ? 'var(--cyan-soft)' : 'var(--surface2)', border: tarifType === 'membre' ? '2px solid var(--cyan)' : '2px solid var(--border)', textAlign: 'center', cursor: 'pointer' }}
                            data-testid="tarif-membre"
                          >
                            <div style={{ fontSize: '10px', color: tarifType === 'membre' ? 'var(--cyan)' : 'var(--muted)' }}>Membre</div>
                            <div style={{ fontSize: '16px', fontWeight: 800 }}>{selectedSeat.prixMembre}€</div>
                            <div style={{ fontSize: '9px', color: 'var(--green)' }}>-{Math.round(100 - selectedSeat.prixMembre * 100 / selectedSeat.prixPublic)}% 🎁</div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', paddingTop: '8px', borderTop: '1px solid var(--border)' }}>
                          <span style={{ color: 'var(--muted)' }}>Total</span>
                          <strong style={{ color: 'var(--gold)', fontSize: '16px' }} data-testid="panier-total">{currentPrice}€</strong>
                        </div>
                      </div>
                      <button className="btn btn-gold btn-full" onClick={ouvrirAchat} data-testid="btn-reserver">🎫 Réserver ce billet →</button>
                    </div>
                  )}
                </div>
              </div>

              {/* BILLET EXEMPLE */}
              <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '10px', color: 'var(--muted)' }}>Exemple de billet reçu par email :</div>
              <div className="billet">
                <div className="billet-top">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                    <div>
                      <div style={{ fontSize: '11px', fontWeight: 700, color: 'var(--gold)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>Le Caveau Blues · Lyon</div>
                      <div style={{ fontFamily: "'Fraunces',serif", fontSize: '20px', fontWeight: 900 }}>Jazz Night 🎷</div>
                    </div>
                    <span className="chip chip-gold">⭐ VIP</span>
                  </div>
                  <div style={{ fontSize: '13px', color: 'var(--muted)', display: 'flex', flexDirection: 'column', gap: '3px' }}>
                    <div>📅 Vendredi 20 Juin 2024 · 20h30</div>
                    <div>🪑 Siège A-2 · Rangée A</div>
                    <div>👤 Marie Dupont</div>
                  </div>
                </div>
                <div className="billet-bottom">
                  <div>
                    <div style={{ fontSize: '10px', color: 'var(--muted)', marginBottom: '2px' }}>N° Billet</div>
                    <div style={{ fontFamily: 'monospace', fontSize: '12px', color: 'var(--gold)' }}>BLT-2024-00847</div>
                    <div style={{ fontSize: '18px', fontWeight: 900, color: 'var(--gold)', marginTop: '4px' }}>45€</div>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <div className="billet-qr">⬛</div>
                    <div style={{ fontSize: '9px', color: 'var(--muted)', marginTop: '4px' }}>Scan à l'entrée</div>
                  </div>
                </div>
              </div>

              {/* ABONNEMENT SAISON */}
              <div style={{ marginTop: '14px', background: 'linear-gradient(135deg,#1a0d2e,#0d1a2e)', border: '1px solid var(--purple)', borderRadius: '14px', padding: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: 800, color: 'var(--purple)', marginBottom: '6px' }}>🎭 Abonnement Saison 2024</div>
                <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '12px', lineHeight: 1.6 }}>Accès à <strong style={{ color: 'var(--text)' }}>tous les concerts</strong> de la saison. Priorité de réservation + 40% de réduction.</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '24px', fontWeight: 900, color: 'var(--purple)' }}>180€</div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)' }}>12 concerts inclus</div>
                  </div>
                  <button className="btn btn-purple btn-sm" onClick={() => toast('Abonnement saison — redirection paiement Stripe')}>S'abonner →</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════ VUE 2 : SALON PROFESSIONNEL ════ */}
      <div className={'view' + (view === 'salon' ? ' active' : '')} style={{ paddingTop: '62px' }} data-testid="view-salon">
        <div style={{ background: 'linear-gradient(180deg,#0a1018,#05080a)', padding: '50px 32px 30px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', gap: '24px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '280px' }}>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', flexWrap: 'wrap' }}>
                <span className="chip chip-cyan">🏢 Salon Professionnel</span>
                <span className="chip chip-ok">✅ Inscriptions ouvertes</span>
                <span className="chip chip-gold">32 emplacements disponibles</span>
              </div>
              <div style={{ fontFamily: "'Fraunces',serif", fontSize: 'clamp(26px,4vw,46px)', fontWeight: 900, lineHeight: 1.1, marginBottom: '10px' }}>Forum Business<br /><span style={{ color: 'var(--cyan)' }}>Lyon 2024</span></div>
              <div style={{ fontSize: '14px', color: 'var(--muted)', marginBottom: '4px' }}>📍 Parc des Expositions Eurexpo · Lyon</div>
              <div style={{ fontSize: '14px', color: 'var(--muted)', marginBottom: '4px' }}>📅 Samedi 28 Septembre 2024 · 9h00 → 18h00</div>
              <div style={{ fontSize: '14px', color: 'var(--muted)', marginBottom: '16px' }}>👥 Public attendu : <strong style={{ color: 'var(--text)' }}>1 500 visiteurs</strong></div>
            </div>
            <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '16px', padding: '20px', minWidth: '300px' }}>
              <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '14px' }}>💰 Tarifs des emplacements</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
                {[
                  { name: '🏆 Island (îlot central)', desc: '16m² · Toutes faces accessibles', price: '1 200€', bg: 'var(--gold-soft)', border: 'var(--gold-border)', color: 'var(--gold)' },
                  { name: '🔝 Corner (angle)', desc: '12m² · 2 faces accessibles', price: '800€', bg: 'rgba(155,89,182,0.08)', border: 'rgba(155,89,182,0.2)', color: 'var(--purple)' },
                  { name: '⭐ Premium (bord allée)', desc: '9m² · 1 face principale', price: '550€', bg: 'rgba(79,138,255,0.08)', border: 'rgba(79,138,255,0.2)', color: 'var(--blue)' },
                  { name: '📦 Standard', desc: '6m² · Inclus table + 2 chaises', price: '350€', bg: 'rgba(34,211,160,0.06)', border: 'rgba(34,211,160,0.2)', color: 'var(--green)' },
                ].map((t) => (
                  <div key={t.name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: t.bg, border: `1px solid ${t.border}`, borderRadius: '10px' }}>
                    <div>
                      <div style={{ fontWeight: 700, color: t.color }}>{t.name}</div>
                      <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{t.desc}</div>
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: 900, color: t.color }}>{t.price}</div>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '10px', padding: '8px', background: 'var(--surface2)', borderRadius: '8px' }}>Tout emplacement inclut : électricité · Wifi · Badge exposant · Listing catalogue</div>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '28px 24px' }}>
          <div style={{ fontSize: '15px', fontWeight: 800, marginBottom: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            🗺️ Plan du salon — Cliquez sur un emplacement pour réserver
            <div className="live-dot"></div>
            <span style={{ fontSize: '12px', fontWeight: 400, color: 'var(--muted)' }}>Mise à jour en temps réel</span>
          </div>

          <div className="salon-map">
            <div style={{ textAlign: 'center', marginBottom: '12px' }}>
              <div className="entree-badge">🚪 ENTRÉE PRINCIPALE</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6,1fr)', gap: '8px', minWidth: '680px' }}>
              <div className="allees-h">— Allée Principale A —</div>
              {SALON_EMPLACEMENTS.slice(0, 6).map((emp) => (
                <div
                  key={emp.id}
                  className={`emplacement ${emp.cls}${emp.sold ? ' emp-sold' : ''}`}
                  onClick={() => !emp.sold && ouvrirEmplacement(emp)}
                  data-testid={`emp-${emp.id}`}
                >
                  <div className="emp-name" style={{ color: emp.sold ? 'var(--muted)' : emp.color }}>{emp.label}</div>
                  <div className="emp-size">{emp.surface}</div>
                  <div className="emp-price" style={{ color: emp.sold ? 'var(--muted)' : emp.color }}>{emp.sold ? 'Réservé' : `${emp.prix}€`}</div>
                  {emp.company && <div className="emp-company">{emp.company}</div>}
                </div>
              ))}
              <div className="allees-h">— Allée B —</div>
              {SALON_EMPLACEMENTS.slice(6, 10).map((emp) => (
                <div
                  key={emp.id}
                  className={`emplacement ${emp.cls}${emp.sold ? ' emp-sold' : ''}`}
                  style={emp.span ? { gridColumn: `span ${emp.span}` } : undefined}
                  onClick={() => !emp.sold && ouvrirEmplacement(emp)}
                  data-testid={`emp-${emp.id}`}
                >
                  <div className="emp-name" style={{ color: emp.sold ? 'var(--muted)' : emp.color }}>{emp.label}</div>
                  <div className="emp-size">{emp.surface}</div>
                  <div className="emp-price" style={{ color: emp.sold ? 'var(--muted)' : emp.color }}>{emp.sold ? 'Réservé' : `${emp.prix}€`}</div>
                  {emp.company && <div className="emp-company">{emp.company}</div>}
                </div>
              ))}
              <div className="allees-h">— Allée C —</div>
              {SALON_EMPLACEMENTS.slice(10).map((emp) => (
                <div
                  key={emp.id}
                  className={`emplacement ${emp.cls}${emp.sold ? ' emp-sold' : ''}`}
                  onClick={() => !emp.sold && ouvrirEmplacement(emp)}
                  data-testid={`emp-${emp.id}`}
                >
                  <div className="emp-name" style={{ color: emp.sold ? 'var(--muted)' : emp.color }}>{emp.label}</div>
                  <div className="emp-size">{emp.surface}</div>
                  <div className="emp-price" style={{ color: emp.sold ? 'var(--muted)' : emp.color }}>{emp.sold ? 'Réservé' : `${emp.prix}€`}</div>
                  {emp.company && <div className="emp-company">{emp.company}</div>}
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', marginTop: '16px', flexWrap: 'wrap' }}>
              {[
                { bg: 'var(--gold)', label: 'Island 1 200€' },
                { bg: 'var(--purple)', label: 'Corner 800€' },
                { bg: 'var(--blue)', label: 'Premium 550€' },
                { bg: 'var(--green)', label: 'Standard 350€' },
                { bg: 'var(--surface2)', label: 'Réservé', border: '1px solid var(--border)' },
              ].map((l) => (
                <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '11px', color: 'var(--muted)' }}>
                  <div style={{ width: '14px', height: '14px', borderRadius: '4px', background: l.bg, opacity: l.border ? 1 : 0.5, border: l.border }}></div>
                  {l.label}
                </div>
              ))}
            </div>
          </div>

          <div className="kpi-row" style={{ marginTop: '20px' }}>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--cyan)' }}>32</div><div className="kpi-lbl">Emplacements total</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>18</div><div className="kpi-lbl">Réservés</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--gold)' }}>14</div><div className="kpi-lbl">Disponibles</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>12 850€</div><div className="kpi-lbl">Revenus emplacements</div><div className="kpi-trend up">↑ 56% rempli</div></div>
          </div>
        </div>
      </div>

      {/* ════ VUE 3 : ADMIN ════ */}
      <div className={'view' + (view === 'admin' ? ' active' : '')} style={{ paddingTop: '62px' }} data-testid="view-admin">
        <div style={{ padding: '22px', maxWidth: '1200px', margin: '0 auto' }}>
          <div className="kpi-row">
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--gold)' }}>{kpiBillets}</div><div className="kpi-lbl">Billets vendus</div><div className="kpi-trend up">↑ +12 aujourd'hui</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>5 847€</div><div className="kpi-lbl">Revenus billetterie</div><div className="kpi-trend up">↑ +340€ ce soir</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--cyan)' }}>{scanOkCount}</div><div className="kpi-lbl">Scans QR entrée</div><div className="kpi-trend up">↑ Live</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--purple)' }}>{cashRecharge.toLocaleString('fr-FR')}€</div><div className="kpi-lbl">Cashless rechargé</div><div className="kpi-trend up">↑ +80€</div></div>
          </div>

          <div className="g2">
            <div className="card">
              <div className="card-hdr"><div className="card-title">📊 Remplissage en temps réel</div><span style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: 'var(--green)' }}><span className="live-dot"></span> Live</span></div>
              <div className="card-body">
                {[
                  { zone: '⭐ VIP', color: 'var(--gold)', pct: 70, txt: '14/20 vendus (70%)' },
                  { zone: '🤝 Partenaire', color: 'var(--purple)', pct: 70, txt: '28/40 vendus (70%)' },
                  { zone: '🪑 Standard', color: 'var(--blue)', pct: 86, txt: '69/80 vendus (86%)' },
                  { zone: '🕺 Debout', color: 'var(--green)', pct: 53, txt: '42/80 vendus (53%)' },
                ].map((r) => (
                  <div key={r.zone} style={{ marginBottom: '14px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '5px' }}><span style={{ color: r.color }}>{r.zone}</span><strong>{r.txt}</strong></div>
                    <div className="prog"><div className="prog-fill" style={{ width: `${r.pct}%`, background: r.color }}></div></div>
                  </div>
                ))}
                <div style={{ marginTop: '16px', padding: '12px', background: 'var(--surface2)', borderRadius: '10px', fontSize: '12px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px' }}><span style={{ color: 'var(--muted)' }}>Total général</span><strong>{kpiBillets}/220 (70%)</strong></div>
                  <div className="prog"><div className="prog-fill" style={{ width: '70%', background: 'linear-gradient(to right,var(--gold),var(--green))' }}></div></div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-hdr"><div className="card-title">💰 Revenus par catégorie</div><button className="btn btn-ghost btn-sm" onClick={() => toast('Export CSV généré !')}>Exporter</button></div>
              <div className="card-body">
                <div style={{ fontSize: '12px' }}>
                  {[
                    { label: 'VIP (14 × 45€)', amount: '630€', color: 'var(--gold)' },
                    { label: 'Partenaire (28 × 35€)', amount: '980€', color: 'var(--purple)' },
                    { label: 'Standard (69 × 25€)', amount: '1 725€', color: 'var(--blue)' },
                    { label: 'Debout (42 × 15€)', amount: '630€', color: 'var(--green)' },
                    { label: 'Cashless rechargements', amount: '1 240€', color: 'var(--cyan)' },
                    { label: 'Publicités in-app', amount: '642€', color: 'var(--orange)' },
                  ].map((r) => (
                    <div key={r.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}><div style={{ width: '10px', height: '10px', borderRadius: '50%', background: r.color }}></div>{r.label}</div>
                      <strong style={{ color: r.color }}>{r.amount}</strong>
                    </div>
                  ))}
                  <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0 0', fontSize: '14px' }}><strong>Total général</strong><strong style={{ color: 'var(--gold)', fontSize: '18px' }}>5 847€</strong></div>
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-hdr">
              <div className="card-title">🎫 Billets vendus</div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <span className="chip chip-gold">{kpiBillets} billets</span>
                <button className="btn btn-ghost btn-sm" onClick={() => toast('Export liste billets PDF généré !')}>📄 Export</button>
              </div>
            </div>
            <div className="tw">
              <table>
                <thead><tr><th>Billet</th><th>Titulaire</th><th>Zone</th><th>Siège</th><th>Tarif</th><th>Prix</th><th>Scan</th><th>Statut</th></tr></thead>
                <tbody>
                  {[
                    ['BLT-00847', 'Marie Dupont', 'VIP', 'chip-gold', 'A-2', 'Public', '45€', 'var(--gold)', 'scanned'],
                    ['BLT-00848', 'Jean Martin', 'VIP', 'chip-gold', 'A-1', 'Membre', '32€', 'var(--gold)', 'scanned'],
                    ['BLT-00849', 'Sophie Bernard', 'Partenaire', 'chip-purple', 'C-2', 'Public', '35€', 'var(--purple)', 'pending'],
                    ['BLT-00850', 'Pierre Durand', 'Standard', 'chip-blue', 'E-3', 'Membre', '18€', 'var(--blue)', 'scanned'],
                    ['BLT-00851', 'Thomas Moreau', 'Debout', null, 'Fosse', 'Public', '15€', 'var(--green)', 'absent'],
                  ].map((row) => {
                    const [bn, holder, zone, chip, seat, tar, prix, color, st] = row;
                    return (
                      <tr key={bn}>
                        <td style={{ fontFamily: 'monospace', fontSize: '11px', color: 'var(--muted)' }}>{bn}</td>
                        <td style={{ fontWeight: 600 }}>{holder}</td>
                        <td>{chip ? <span className={`chip ${chip}`} style={{ fontSize: '9px' }}>{zone}</span> : <span style={{ color: 'var(--muted)' }}>{zone}</span>}</td>
                        <td>{seat}</td>
                        <td style={{ fontSize: '11px', color: tar === 'Membre' ? 'var(--cyan)' : 'var(--muted)' }}>{tar}</td>
                        <td style={{ fontWeight: 700, color }}>{prix}</td>
                        <td>
                          {st === 'scanned' ? <span className="chip chip-ok" style={{ fontSize: '9px' }}>✓ Scanné</span>
                            : st === 'pending' ? <span className="chip chip-warn" style={{ fontSize: '9px' }}>En attente</span>
                            : <span className="chip chip-err" style={{ fontSize: '9px' }}>Non scanné</span>}
                        </td>
                        <td>
                          {st === 'scanned' ? <span className="chip chip-ok" style={{ fontSize: '9px' }}>Entré</span>
                            : <span className="chip chip-warn" style={{ fontSize: '9px' }}>Pas encore entré</span>}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ════ VUE 4 : SCAN ════ */}
      <div className={'view' + (view === 'scan' ? ' active' : '')} style={{ paddingTop: '62px' }} data-testid="view-scan">
        <div style={{ maxWidth: '600px', margin: '0 auto', padding: '28px 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ fontFamily: "'Fraunces',serif", fontSize: '28px', fontWeight: 900, marginBottom: '6px' }}>📱 Scan QR Code</div>
            <div style={{ fontSize: '14px', color: 'var(--muted)' }}>Jazz Night — Vendredi 20 Juin · Le Caveau Blues</div>
          </div>

          <div style={{ background: '#000', borderRadius: '16px', overflow: 'hidden', position: 'relative', height: '300px', marginBottom: '20px', border: '2px solid var(--gold-border)' }}>
            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '12px' }}>
              <div style={{ width: '200px', height: '200px', position: 'relative' }}>
                <div style={{ position: 'absolute', top: '-2px', left: '-2px', width: '30px', height: '30px', borderTop: '3px solid var(--gold)', borderLeft: '3px solid var(--gold)', borderRadius: '4px 0 0 0' }}></div>
                <div style={{ position: 'absolute', top: '-2px', right: '-2px', width: '30px', height: '30px', borderTop: '3px solid var(--gold)', borderRight: '3px solid var(--gold)', borderRadius: '0 4px 0 0' }}></div>
                <div style={{ position: 'absolute', bottom: '-2px', left: '-2px', width: '30px', height: '30px', borderBottom: '3px solid var(--gold)', borderLeft: '3px solid var(--gold)', borderRadius: '0 0 0 4px' }}></div>
                <div style={{ position: 'absolute', bottom: '-2px', right: '-2px', width: '30px', height: '30px', borderBottom: '3px solid var(--gold)', borderRight: '3px solid var(--gold)', borderRadius: '0 0 4px 0' }}></div>
                <div className="scan-line"></div>
              </div>
              <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>Pointez la caméra vers le QR code du billet</div>
            </div>
            <div style={{ position: 'absolute', bottom: '14px', left: 0, right: 0, textAlign: 'center' }}>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'rgba(0,0,0,0.7)', padding: '6px 14px', borderRadius: '20px', fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>
                <span className="live-dot"></span> Caméra active
              </div>
            </div>
          </div>

          <button className="btn btn-gold btn-full btn-lg" onClick={simulerScan} style={{ marginBottom: '12px' }} data-testid="btn-simuler-scan">🔍 Simuler un scan</button>

          {scanResult && (
            <div data-testid="scan-result-block">
              {scanResult.ok ? (
                <div style={{ background: 'rgba(34,211,160,0.08)', border: '2px solid var(--green)', borderRadius: '14px', padding: '18px', textAlign: 'center', marginBottom: '16px' }}>
                  <div style={{ fontSize: '36px', marginBottom: '8px' }}>✅</div>
                  <div style={{ fontSize: '18px', fontWeight: 800, color: 'var(--green)' }}>ACCÈS AUTORISÉ</div>
                  <div style={{ fontSize: '14px', fontWeight: 700, marginTop: '6px' }}>{scanResult.name}</div>
                  <div style={{ fontSize: '12px', color: 'var(--muted)' }}>Siège {scanResult.seat} · {scanResult.zone}</div>
                </div>
              ) : (
                <div style={{ background: 'rgba(255,92,106,0.08)', border: '2px solid var(--red)', borderRadius: '14px', padding: '18px', textAlign: 'center', marginBottom: '16px' }}>
                  <div style={{ fontSize: '36px', marginBottom: '8px' }}>❌</div>
                  <div style={{ fontSize: '18px', fontWeight: 800, color: 'var(--red)' }}>ACCÈS REFUSÉ</div>
                  <div style={{ fontSize: '13px', color: 'var(--muted)', marginTop: '6px' }}>QR code invalide ou billet déjà utilisé</div>
                </div>
              )}
            </div>
          )}

          <div className="kpi-row" style={{ gridTemplateColumns: 'repeat(3,1fr)', marginTop: '20px' }}>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }} data-testid="scan-ok-count">{scanOkCount}</div><div className="kpi-lbl">Entrées validées</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--red)' }}>3</div><div className="kpi-lbl">Billets invalides</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--orange)' }}>{scanTotal}</div><div className="kpi-lbl">Billets émis</div></div>
          </div>

          <div className="card" style={{ marginTop: '14px' }}>
            <div className="card-hdr"><div className="card-title">🕐 Historique scans</div></div>
            <div style={{ padding: 0 }}>
              {scanHistory.map((h, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 16px', borderBottom: i < scanHistory.length - 1 ? '1px solid rgba(26,36,48,0.5)' : 'none' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '9px', background: h.ok ? 'rgba(34,211,160,0.1)' : 'rgba(255,92,106,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px' }}>{h.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: 600 }}>{h.name}</div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{h.meta}</div>
                  </div>
                  <span className={'chip ' + (h.ok ? 'chip-ok' : 'chip-err')}>{h.ok ? 'Validé' : 'Refusé'}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ════ VUE 5 : CASHLESS ════ */}
      <div className={'view' + (view === 'cashless' ? ' active' : '')} style={{ paddingTop: '62px' }} data-testid="view-cashless">
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '28px 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '28px' }}>
            <div style={{ fontFamily: "'Fraunces',serif", fontSize: '28px', fontWeight: 900, marginBottom: '6px' }}>💳 Cashless</div>
            <div style={{ fontSize: '14px', color: 'var(--muted)' }}>Carte rechargeable sans contact · Zéro espèces</div>
          </div>

          <div className="g2" style={{ gap: '24px', marginBottom: '24px' }}>
            <div>
              <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--muted)', marginBottom: '10px' }}>Votre carte cashless :</div>
              <div className="cashless-card-vis">
                <div className="cashless-chip"></div>
                <div className="cashless-num">4847 •••• •••• 2847</div>
                <div className="cashless-name">Marie Dupont</div>
                <div style={{ fontSize: '11px', color: 'var(--muted)', marginBottom: '6px' }}>Solde disponible</div>
                <div className="cashless-balance" data-testid="cash-balance">{cashBalance.toFixed(2)}€</div>
                <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>Rechargé ce soir : 30€ · Dépensé : 5,50€</div>
                <div style={{ display: 'flex', gap: '8px', marginTop: '14px' }}>
                  <button className="btn btn-gold btn-sm" onClick={() => toast('💳 Sélectionnez un montant ci-dessous')}>💳 Recharger</button>
                  <button className="btn btn-ghost btn-sm" onClick={() => toast('Historique transactions affiché')}>📋 Historique</button>
                </div>
              </div>

              <div style={{ marginTop: '14px', fontSize: '13px', fontWeight: 700, marginBottom: '8px' }}>Recharger ma carte :</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '8px' }}>
                {[10, 20, 30, 50].map((amount) => (
                  <div
                    key={amount}
                    onClick={() => addBalance(amount)}
                    style={{ padding: '12px', background: amount === 30 ? 'var(--gold-soft)' : 'var(--surface2)', border: amount === 30 ? '1px solid var(--gold-border)' : '1px solid var(--border)', borderRadius: '10px', textAlign: 'center', cursor: 'pointer' }}
                    data-testid={`recharge-${amount}`}
                  >
                    <div style={{ fontSize: '16px', fontWeight: 800, color: 'var(--gold)' }}>{amount}€</div>
                    {amount === 30 && <div style={{ fontSize: '9px', color: 'var(--gold)' }}>Populaire</div>}
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--muted)', marginBottom: '10px' }}>Menu bar cashless :</div>
              <div className="card">
                <div className="card-hdr"><div className="card-title">🍺 Bar · Le Caveau Blues</div></div>
                <div className="card-body" style={{ padding: 0 }}>
                  {[
                    { name: '🍺 Bière pression', desc: '50cl', price: 4.50 },
                    { name: '🍷 Verre de vin', desc: 'Rouge / Blanc / Rosé', price: 5.00 },
                    { name: '🥂 Cocktail', desc: 'Mojito, Spritz, Daiquiri', price: 8.00 },
                    { name: '🥤 Soft / Eau', desc: '', price: 2.50 },
                    { name: '🧀 Planche apéro', desc: 'Fromages + charcuterie', price: 12.00 },
                  ].map((p, i, arr) => (
                    <div key={p.name} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderBottom: i < arr.length - 1 ? '1px solid rgba(26,36,48,0.5)' : 'none' }}>
                      <div>
                        <div style={{ fontSize: '13px', fontWeight: 600 }}>{p.name}</div>
                        {p.desc && <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{p.desc}</div>}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontWeight: 700, color: 'var(--gold)' }}>{p.price.toFixed(2)}€</span>
                        <button className="btn btn-gold btn-sm" onClick={() => payer(p.price, p.name)} data-testid={`payer-${p.name.replace(/[^a-zA-Z]/g, '').toLowerCase()}`}>Payer</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-hdr"><div className="card-title">📊 Stats cashless — Soirée en cours</div><span className="live-dot"></span></div>
            <div className="card-body">
              <div className="g4">
                {[
                  { val: `${cashRecharge.toLocaleString('fr-FR')}€`, lbl: 'Total rechargé', color: 'var(--gold)' },
                  { val: '892€', lbl: 'Total dépensé', color: 'var(--green)' },
                  { val: '348€', lbl: 'Solde restant', color: 'var(--cyan)' },
                  { val: '7,12€', lbl: 'Panier moyen', color: 'var(--purple)' },
                ].map((s) => (
                  <div key={s.lbl} style={{ textAlign: 'center', padding: '14px', background: 'var(--surface2)', borderRadius: '12px' }}>
                    <div style={{ fontSize: '22px', fontWeight: 800, color: s.color }}>{s.val}</div>
                    <div style={{ fontSize: '11px', color: 'var(--muted)' }}>{s.lbl}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════ VUE 6 : SPONSORS ════ */}
      <div className={'view' + (view === 'sponsors' ? ' active' : '')} style={{ paddingTop: '62px' }} data-testid="view-sponsors">
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '28px 20px' }}>
          <div className="kpi-row">
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--gold)' }}>6</div><div className="kpi-lbl">Sponsors actifs</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--green)' }}>3 200€</div><div className="kpi-lbl">Revenus sponsoring</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--cyan)' }}>12</div><div className="kpi-lbl">Slots pub vendus</div></div>
            <div className="kpi"><div className="kpi-val" style={{ color: 'var(--orange)' }}>642€</div><div className="kpi-lbl">Revenus pub in-app</div></div>
          </div>

          <div className="g2">
            <div>
              <div style={{ fontSize: '15px', fontWeight: 800, marginBottom: '14px' }}>🤝 Sponsors & Partenaires</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
                {[
                  { icon: '🏦', name: 'Crédit Agricole du Lot', role: 'Sponsor Titre — Logo sur billets + bannière scène', amount: '1 500€', paid: true, chipColor: 'chip-gold', iconBg: 'linear-gradient(135deg,var(--gold),#c8840a)', border: 'var(--gold-border)' },
                  { icon: '🍕', name: 'Pizzeria da Marco', role: 'Partenaire Bar — Mentions sur billetterie', amount: '800€', paid: true, chipColor: 'chip-blue', iconBg: 'rgba(79,138,255,0.15)', border: 'var(--border)' },
                  { icon: '🎸', name: 'Guitare Plus Figeac', role: 'Partenaire Matériel — Logo backline', amount: '500€', paid: false, chipColor: 'chip-purple', iconBg: 'rgba(155,89,182,0.15)', border: 'var(--border)' },
                ].map((s) => (
                  <div key={s.name} style={{ background: 'var(--surface)', border: `1px solid ${s.border}`, borderRadius: '14px', padding: '16px', display: 'flex', alignItems: 'center', gap: '14px' }}>
                    <div style={{ width: '50px', height: '50px', borderRadius: '12px', background: s.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0 }}>{s.icon}</div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: 800 }}>{s.name}</div>
                      <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '2px' }}>{s.role}</div>
                      <div style={{ display: 'flex', gap: '6px', marginTop: '6px' }}>
                        <span className={'chip ' + s.chipColor}>{s.amount}</span>
                        <span className={'chip ' + (s.paid ? 'chip-ok' : 'chip-warn')}>{s.paid ? 'Payé' : 'En attente'}</span>
                      </div>
                    </div>
                    <button className="btn btn-ghost btn-sm" onClick={() => toast(s.paid ? 'Rapport ROI envoyé !' : 'Relance envoyée !')}>{s.paid ? '📊 ROI' : '📧 Relancer'}</button>
                  </div>
                ))}
              </div>
              <button className="btn btn-gold btn-full" onClick={() => toast('Nouveau sponsor — formulaire ouvert')}>＋ Ajouter un sponsor</button>

              <div style={{ marginTop: '16px', background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: '14px', padding: '16px' }}>
                <div style={{ fontSize: '13px', fontWeight: 700, marginBottom: '10px' }}>📊 ROI Sponsors — Rapport automatique</div>
                <div style={{ fontSize: '12px', color: 'var(--muted)', marginBottom: '12px', lineHeight: 1.6 }}>Rapport mensuel envoyé automatiquement à chaque sponsor avec leurs statistiques de visibilité.</div>
                <div style={{ fontSize: '12px' }}>
                  {[
                    ['Vues logo sur billets', '1 840', null],
                    ['Clics pub in-app', '324', 'var(--cyan)'],
                    ['Mentions réseaux sociaux', '48', null],
                    ['Rapport envoyé aux sponsors', 'Automatique', 'var(--green)'],
                  ].map(([lbl, val, col], i, arr) => (
                    <div key={lbl} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
                      <span style={{ color: 'var(--muted)' }}>{lbl}</span><strong style={col ? { color: col } : undefined}>{val}</strong>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div>
              <div style={{ fontSize: '15px', fontWeight: 800, marginBottom: '14px' }}>📱 Publicités in-app & sur billets</div>
              <div style={{ fontSize: '12px', fontWeight: 700, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '10px' }}>Emplacements disponibles</div>

              {[
                { label: '📱 Bannière top application · 150€/soirée', filled: true, content: <><div style={{ width: '200px', height: '40px', background: 'linear-gradient(90deg,#1a0d05,#2e1a08)', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', flexShrink: 0 }}><span style={{ fontSize: '11px', fontWeight: 700, color: 'var(--gold)' }}>🏦 Crédit Agricole</span></div><div style={{ flex: 1, fontSize: '12px', color: 'var(--muted)' }}>324 clics ce soir</div><span className="chip chip-gold">150€/soir</span></> },
                { label: '🎫 Logo sur billet · 100€/soirée', filled: true, content: <><div style={{ width: '80px', height: '30px', background: 'rgba(245,166,35,0.1)', border: '1px solid var(--gold-border)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700, color: 'var(--gold)', flexShrink: 0 }}>SPONSOR</div><div style={{ flex: 1, fontSize: '12px', color: 'var(--muted)' }}>Imprimé sur {kpiBillets} billets</div><span className="chip chip-gold">100€/soir</span></> },
                { label: '🔔 Notification push aux membres · 80€', empty: true, msg: 'Disponible — Cliquez pour réserver · 247 membres · 80€', onClick: () => toast('Slot notification push réservé !') },
                { label: '💳 Écran cashless (visuel paiement) · 120€', filled: true, content: <><div style={{ width: '120px', height: '36px', background: 'rgba(79,138,255,0.1)', border: '1px solid rgba(79,138,255,0.2)', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700, color: 'var(--blue)', flexShrink: 0 }}>🍕 Pizzeria Marco</div><div style={{ flex: 1, fontSize: '12px', color: 'var(--muted)' }}>892 transactions affichées</div><span className="chip chip-blue">120€/soir</span></> },
                { label: '✅ Page confirmation billet · 60€', empty: true, msg: 'Disponible — Vue par 100% des acheteurs · 60€', onClick: () => toast('Slot confirmation billet réservé !') },
              ].map((slot) => (
                <div key={slot.label} style={{ marginBottom: '8px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--muted)', marginBottom: '4px' }}>{slot.label}</div>
                  {slot.empty ? (
                    <div style={{ background: 'var(--surface)', border: '2px dashed var(--border)', borderRadius: '10px', padding: '12px 16px', cursor: 'pointer' }} onClick={slot.onClick}>
                      <div style={{ fontSize: '12px', color: 'var(--muted)', textAlign: 'center' }}>{slot.msg}</div>
                    </div>
                  ) : (
                    <div style={{ background: 'var(--surface)', border: '1px solid var(--gold-border)', borderRadius: '10px', padding: '12px 16px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {slot.content}
                    </div>
                  )}
                </div>
              ))}

              <button className="btn btn-ghost btn-full" style={{ marginTop: '8px' }} onClick={() => toast('Grille tarifaire complète envoyée par email')}>📋 Grille tarifaire complète →</button>

              <div style={{ marginTop: '14px', background: 'var(--gold-soft)', border: '1px solid var(--gold-border)', borderRadius: '12px', padding: '16px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: 800 }}>Total revenus publicitaires</div>
                    <div style={{ fontSize: '12px', color: 'var(--muted)' }}>Cette soirée</div>
                  </div>
                  <div style={{ fontSize: '26px', fontWeight: 900, color: 'var(--gold)' }}>642€</div>
                </div>
                <div style={{ marginTop: '10px', fontSize: '12px', color: 'var(--muted)', lineHeight: 1.6 }}>Les revenus publicitaires sont un complément aux billets. Sur une saison complète, cela représente plusieurs milliers d'euros supplémentaires pour votre lieu.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══ MODAL ACHAT BILLET ══ */}
      <div className={'modal-bg' + (modalBillet ? ' open' : '')} onClick={(e) => e.target === e.currentTarget && setModalBillet(false)} data-testid="modal-billet">
        <div className="modal">
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ fontSize: '40px', marginBottom: '8px' }}>🎷</div>
            <div style={{ fontFamily: "'Fraunces',serif", fontSize: '20px', fontWeight: 900, marginBottom: '4px' }} data-testid="modal-event-name">Jazz Night — Vendredi 20 Juin</div>
            <div style={{ fontSize: '13px', color: 'var(--muted)' }}>Le Caveau Blues · Lyon 1er</div>
          </div>
          <div style={{ background: 'var(--surface2)', borderRadius: '12px', padding: '14px', marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <div style={{ fontSize: '13px', fontWeight: 700 }}>
                {selectedSeat && (selectedSeat.id === 'Fosse' ? 'Zone Debout — Fosse' : `Siège ${selectedSeat.id} — Zone ${selectedSeat.zone}`)}
              </div>
              {selectedSeat && <span className={'chip ' + getZoneConfig(selectedSeat.zone).chipClass}>{selectedSeat.zone}</span>}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: 'var(--muted)' }}>
              <span>Tarif sélectionné</span>
              <strong style={{ color: 'var(--gold)', fontSize: '16px' }}>{currentPrice}€</strong>
            </div>
          </div>
          {selectedSeat && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '14px' }}>
              <div onClick={() => setTarifType('public')} style={{ flex: 1, padding: '10px', borderRadius: '10px', border: tarifType === 'public' ? '2px solid var(--gold)' : '2px solid var(--border)', background: tarifType === 'public' ? 'var(--gold-soft)' : 'var(--surface2)', cursor: 'pointer', textAlign: 'center' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, color: tarifType === 'public' ? 'var(--gold)' : 'var(--muted)' }}>Public</div>
                <div style={{ fontSize: '16px', fontWeight: 900, color: tarifType === 'public' ? 'var(--gold)' : 'var(--text)' }}>{selectedSeat.prixPublic}€</div>
              </div>
              <div onClick={() => setTarifType('membre')} style={{ flex: 1, padding: '10px', borderRadius: '10px', border: tarifType === 'membre' ? '2px solid var(--cyan)' : '2px solid var(--border)', background: tarifType === 'membre' ? 'var(--cyan-soft)' : 'var(--surface2)', cursor: 'pointer', textAlign: 'center' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, color: tarifType === 'membre' ? 'var(--cyan)' : 'var(--muted)' }}>Membre REF</div>
                <div style={{ fontSize: '16px', fontWeight: 900 }}>{selectedSeat.prixMembre}€</div>
                <div style={{ fontSize: '9px', color: 'var(--green)' }}>-{Math.round(100 - selectedSeat.prixMembre * 100 / selectedSeat.prixPublic)}% 🎁</div>
              </div>
            </div>
          )}
          <div className="fg"><label className="fl">Prénom & Nom</label><input className="fi" placeholder="Marie Dupont" value={billetName} onChange={(e) => setBilletName(e.target.value)} data-testid="billet-name" /></div>
          <div className="fg"><label className="fl">Email (reçoit le billet QR)</label><input className="fi" type="email" placeholder="marie@email.fr" value={billetEmail} onChange={(e) => setBilletEmail(e.target.value)} data-testid="billet-email" /></div>
          <div style={{ background: 'var(--gold-soft)', border: '1px solid var(--gold-border)', borderRadius: '10px', padding: '12px', marginBottom: '14px', fontSize: '12px', color: 'var(--muted)' }}>
            🎫 Votre billet avec QR code sera envoyé par email immédiatement après paiement.
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setModalBillet(false)}>Annuler</button>
            <button className="btn btn-gold" style={{ flex: 2 }} onClick={acheterBillet} disabled={submitting} data-testid="btn-payer">{submitting ? '⏳ Traitement Stripe...' : `🔒 Payer ${currentPrice}€ →`}</button>
          </div>
          <div style={{ textAlign: 'center', fontSize: '11px', color: 'var(--muted)', marginTop: '10px' }}>Paiement sécurisé Stripe · Remboursable 48h avant</div>
        </div>
      </div>

      {/* ══ MODAL EMPLACEMENT ══ */}
      <div className={'modal-bg' + (modalEmplacement ? ' open' : '')} onClick={(e) => e.target === e.currentTarget && setModalEmplacement(null)} data-testid="modal-emplacement">
        {modalEmplacement && (
          <div className="modal">
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '36px', marginBottom: '8px' }}>🏢</div>
              <div style={{ fontFamily: "'Fraunces',serif", fontSize: '20px', fontWeight: 900, marginBottom: '4px' }}>Emplacement {modalEmplacement.id}</div>
              <div style={{ fontSize: '13px', color: 'var(--muted)' }}>{modalEmplacement.type} · {modalEmplacement.surface}</div>
            </div>
            <div style={{ background: 'var(--surface2)', borderRadius: '12px', padding: '14px', marginBottom: '16px' }}>
              <div style={{ fontSize: '12px', color: 'var(--muted)', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>Surface</span><strong>{modalEmplacement.surface}</strong></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>Électricité</span><strong style={{ color: 'var(--green)' }}>Incluse</strong></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>Wifi</span><strong style={{ color: 'var(--green)' }}>Inclus</strong></div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>Table + 2 chaises</span><strong style={{ color: 'var(--green)' }}>Incluses</strong></div>
                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '8px', borderTop: '1px solid var(--border)' }}><span style={{ fontSize: '14px', fontWeight: 700 }}>Prix TTC</span><strong style={{ color: 'var(--gold)', fontSize: '20px' }}>{modalEmplacement.prix}€</strong></div>
              </div>
            </div>
            <div className="fg"><label className="fl">Entreprise / Association</label><input className="fi" placeholder="Ma Société SARL" value={empCompany} onChange={(e) => setEmpCompany(e.target.value)} data-testid="emp-company" /></div>
            <div className="fg"><label className="fl">Contact responsable stand</label><input className="fi" placeholder="Jean Dupont — 06 12 34 56 78" value={empContact} onChange={(e) => setEmpContact(e.target.value)} /></div>
            <div className="fg"><label className="fl">Email (reçoit la confirmation)</label><input className="fi" type="email" placeholder="contact@masociete.fr" value={empEmail} onChange={(e) => setEmpEmail(e.target.value)} data-testid="emp-email" /></div>
            <div className="fg"><label className="fl">Description activité (optionnel)</label><textarea className="fi" rows="2" placeholder="Présentation de vos produits / services..."></textarea></div>
            <div style={{ background: 'var(--cyan-soft)', border: '1px solid var(--cyan-border)', borderRadius: '10px', padding: '12px', marginBottom: '14px', fontSize: '12px', color: 'var(--muted)' }}>
              ✅ Votre emplacement est réservé dès le paiement. Confirmation + plan d'accès envoyés par email.
            </div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setModalEmplacement(null)}>Annuler</button>
              <button className="btn btn-gold" style={{ flex: 2 }} onClick={reserverEmplacement} disabled={submitting} data-testid="btn-reserver-emp">{submitting ? '⏳ Traitement...' : `🔒 Réserver & Payer ${modalEmplacement.prix}€ →`}</button>
            </div>
          </div>
        )}
      </div>

      {/* ══ MODAL SUCCÈS ══ */}
      <div className={'modal-bg' + (modalSuccess ? ' open' : '')} onClick={(e) => e.target === e.currentTarget && setModalSuccess(null)} data-testid="modal-success">
        {modalSuccess && (
          <div className="modal" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '56px', marginBottom: '14px' }}>{modalSuccess.icon}</div>
            <div style={{ fontFamily: "'Fraunces',serif", fontSize: '22px', fontWeight: 900, marginBottom: '8px' }}>{modalSuccess.title}</div>
            <div style={{ fontSize: '14px', color: 'var(--muted)', lineHeight: 1.7, marginBottom: '22px' }}>{modalSuccess.msg}</div>
            <button className="btn btn-gold btn-full btn-lg" onClick={() => setModalSuccess(null)} data-testid="btn-success-close">Parfait ! →</button>
          </div>
        )}
      </div>
    </div>
  );
}
